import React, { Component } from "react";
import { withRouter, Redirect } from "react-router";
import { compose } from "react-apollo";
import NewPostLink from "../templates/create-post/NewPostLink";
import ListPostContainer from "../templates/list-post/ListPostContainer";
import withAuthen from "../templates/authenticate/withAuthen";

class HomePage extends Component {

  render() {
    return (
      <div className="container">
        <nav className="nav-extended">
          <div className="nav-wrapper">
            <a href="#" className="brand-logo center">
              Congrats
            </a>
            <ul className="left">
              <li>
                <a onClick={this.props.logout}>Logout</a>
              </li>
            </ul>

            <NewPostLink />
          </div>
        </nav>
        {/* <span>Logged in as ${this.props.data.loggedInUser.id}</span> */}

        <ListPostContainer queryUser={this.props.userQuery} />
      </div>
    );
  }
}

export default compose(withAuthen)(withRouter(HomePage));



// WEBPACK FOOTER //
// ./src/pages/HomePage.js